var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-4"},[_c('tree-navigation',{staticClass:"treeDiv",attrs:{"items":_vm.items,"dialogTitle":"Browse Documentation"}}),_c('div',{staticStyle:{"height":"3em"}},[_vm._v(" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }